import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClassiFabbricatoFormComponent } from './dialogs/form/form.component';
import { ClassiFabbricatoRoutingModule } from './classi-fabbricato-routing.module';
import { ClassiFabbricatoComponent } from './classi-fabbricato.component';
import { CustomMaterialModule } from '../../material-module/material.module';
import { ResourcefulIndexModule } from '../../shared/resourceful-index/resourceful-index.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';

@NgModule({
  declarations: [ClassiFabbricatoComponent, ClassiFabbricatoFormComponent],
  imports: [
    CommonModule,
    ClassiFabbricatoRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CustomMaterialModule,
    CustomFormControlsModule,
    ResourcefulIndexModule,
  ]
})
export class ClassiFabbricatoModule { }
